// Custom Infini10 brand mark + wordmark — no external image dependency
const LogoMark = ({ className = "h-10 w-auto", invert = false }) => {
  const dark = invert ? "#ffffff" : "#1f2a44";
  return (
    <svg
      className={className}
      viewBox="0 0 56 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Infini10 Technologies"
    >
      {/* "1" — rounded vertical pill */}
      <rect x="7" y="10" width="8" height="24" rx="4" fill={dark} />
      {/* small accent dot on top of the 1 (tech vibe) */}
      <circle cx="11" cy="5" r="3" fill="#fe4c1c" />
      {/* "0" — hollow orange ring */}
      <circle cx="36" cy="22" r="12" stroke="#fe4c1c" strokeWidth="5" />
      {/* inner dot for depth */}
      <circle cx="36" cy="22" r="2.5" fill={dark} />
    </svg>
  );
};

const Logo = ({ invert = false, size = "md", showSub = true }) => {
  const textColor = invert ? "text-white" : "text-[#1f2a44]";
  const subColor = "text-[#fe4c1c]";
  return (
    <div className="flex items-center gap-3">
      <LogoMark
        className={size === "lg" ? "h-12 w-auto" : "h-10 w-auto"}
        invert={invert}
      />
      <span className="flex flex-col leading-none">
        <span
          className={`font-display ${
            size === "lg" ? "text-[24px]" : "text-[20px]"
          } font-bold tracking-tight ${textColor}`}
        >
          Infini<span className="text-[#fe4c1c]">10</span>
        </span>
        {showSub && (
          <span
            className={`mt-1 text-[10px] font-semibold tracking-[0.22em] uppercase ${subColor}`}
          >
            Technologies
          </span>
        )}
      </span>
    </div>
  );
};

export { Logo, LogoMark };
export default Logo;
